import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { breadcrumb, breadcrumbResolve, breadcrumbResolved } from 'rise-ui/services/breadcrumb.js';
import { pageNotFoundModel } from 'rise-ui/services/page-not-found-model.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@pageNotFoundModel('page')
@scrollRoot
export default class PageRoute extends Route {
  @service store;

  @breadcrumb crumb = 'Page';

  model({ page_id }) {
    return hash({
      page: this.store.findRecord('page', page_id),
    });
  }

  @breadcrumbResolve modelCrumbResolve(model) {
    return model.page;
  }
  @breadcrumbResolved modelCrumb(model) {
    return model.page.get('title');
  }
}
